import React, { Component } from "react";

class ScheduleOfChargesContent extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="mt-4 mb-3">Schedule of Charges</h2>
              {/* <p className="mb-3">Last Updated on December 29, 2025</p> */}
              <div className="col-12 col-md-12 row">
                <ul style={{ padding: 20, textAlign: "left" }}>
                  <h5 className="mb-2">• Preclosure Charges:</h5>
                  <li className="mb-3 ml-4">
                    {" "}
                    o Refer to the{" "}
                    <a href="/loanclosurepolicy">preclosure policy</a> for
                    detailed information
                  </li>
                  <h5 className="mb-2">• Prepayment Charges:</h5>
                  <li className="mb-3 ml-4">
                    o Refer to the{" "}
                    <a href="/loanclosurepolicy">prepayment policy</a> for
                    detailed information.
                  </li>
                  <h5 className="mb-2">• Penalty Charges:</h5>
                  <li className="mb-3 ml-4">
                    {" "}
                    o Penalty charges are calculated at an annualized rate of
                    36% + appropriate GST on the overdue principal amount,
                    applied on a daily basis without compounding.
                  </li>
                  <h5 className="mb-2">• Credit Report Charges:</h5>
                  <li className="mb-3 ml-4">
                    {" "}
                    o A fixed fee of Rs. 50 + appropriate GST is charged for
                    obtaining a credit report.
                  </li>
                  <h5 className="mb-2">• Insurance Charges:</h5>
                  <li className="mb-3 ml-4"> o NA</li>
                  <h5 className="mb-2">• GST Charges:</h5>
                  <li className="mb-3 ml-4">
                    {" "}
                    o Currently, all our charges will attract 18% GST as per the
                    Government regulations.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ScheduleOfChargesContent;
